export default __webpack_public_path__ + "static/media/power_diode.58896f98.svg";